import React, { Component } from "react";

import { get } from "lodash";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import { Spinner } from "shared-components/decorators/spinner";

import { Tabs } from "../elements-buttons/tab-buttons";
import { StatsigContext } from "../elements-statsig-provider/statsig-context";
import whiteBackground from "../wrapper-components/white-background";

import PaymentsSummary from "./payments-summary";
import PayoutsMain from "./payouts/PayoutsMain";
import { TaxDetailsSection } from "./TaxDetails";
import TaxDetails from "./taxes/TaxDetails";

class PaymentsGuestContainer extends Component {
  static contextType = StatsigContext;

  render() {
    const { flow, fees, isVatEnabled } = this.props;
    const hasFetchedFeesAndRegions = get(fees, "hasFetched", false);
    // Gates the rebuilt Tax Details module; falls back to the legacy section
    // until Statsig resolves, so nothing flashes the new UI then swaps back.
    const isVatValidationEnabled =
      this.context?.featureGates?.vat_validation ?? false;
    const taxSection = isVatValidationEnabled ? (
      // Legacy grid, which the rebuilt module does not carry itself
      <div className="col-xs-12 col-md-8 no-gutter">
        <TaxDetailsSection />
      </div>
    ) : (
      <TaxDetails {...this.props} />
    );

    const tabs = [
      {
        label: (
          <FormattedMessage
            id="hosting.payments_guest_container.payment_methods"
            defaultMessage="Payment Methods"
          />
        ),
        link: "account/methods",
      },
    ];

    if (isVatEnabled) {
      tabs.push({
        label: (
          <FormattedMessage
            id="hosting.payments_guest_container.taxes_tab_text"
            defaultMessage="Taxes"
          />
        ),
        link: "account/taxes",
      });
    }

    return (
      <div className="PaymentsGuest container">
        <h2 className="heading">
          <FormattedMessage
            id="hosting.payments_guest_container.payments_heading"
            defaultMessage="Payments"
          />
        </h2>

        <Tabs tabs={tabs} />

        {(!flow || "methods" === flow) && (
          <PaymentsSummary {...this.props} hideHeading />
        )}

        {"taxes" === flow &&
          (hasFetchedFeesAndRegions ? (
            taxSection
          ) : (
            <div className="spinner-container">
              <Spinner additionalStyle="gray" />
            </div>
          ))}
      </div>
    );
  }
}

PaymentsGuestContainer.propTypes = {
  flow: PropTypes.string,
  isVatEnabled: PropTypes.bool,
  fees: PropTypes.array,
};

export default whiteBackground(PaymentsGuestContainer);
